module.exports = __webpack_public_path__ + "img/icon_1_50.f35f937a.png";